import getBasePath from '../../functions/api-resource';

const basePath = getBasePath('api', 'acao-configuracao-apuracao-template');

const parametrizacaoAcaoActions = {
  buscar: { method: 'GET', url: `${basePath}` },
};

export default (resource) => resource(`${basePath}`, {}, parametrizacaoAcaoActions);
